import { useQuery } from '@tanstack/react-query'

import { useAuth } from '@/lib/auth'
import { useTRPC } from '@/lib/trpc'
import { useUserStreamHealthy } from '@/lib/user-stream'

export function useGameAttention() {
  const trpc = useTRPC()
  const { user, authResolved } = useAuth()
  const streamHealthy = useUserStreamHealthy()
  const query = useQuery({
    ...trpc.userRouter.gameAttention.queryOptions(),
    enabled: authResolved && !!user,
    staleTime: 2_000,
    refetchInterval: streamHealthy ? 15_000 : 5_000,
    refetchOnReconnect: true,
    refetchOnWindowFocus: true,
  })
  const data = authResolved && user && query.data?.userId === user.id
    ? query.data
    : undefined

  return {
    ...query,
    data,
    awaitingCount: data?.awaitingCount ?? 0,
  }
}
